import axios from '../axios/interceptor';

export const getSubscriptionPlans = async () => {
    const response = await axios.get('/subscription-plans');
    return response.data;
}